/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.16.0
 * @since 1.16.0
 */

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { InfoBlock } from '../../../components/common';
import { EColorStatus } from '../../../modules/app/appConstants';
import {
    makeSelectTranslationWizardImportPersonalData,
} from '../../../modules/internationalization/intSelectors';
import { IWizardImportPersonalDataTranslation } from '../../../modules/internationalization/types/wizards/importPersonalData';
import { IRootReducer } from '../../../reducers/rootReducer';
import { stringFormatParams } from '../../../utils/stringFormat';
import { EWizardImportPersonalDataSteps } from '../wizardImportPersonalDataConstant';
import { IWizardImportPersonalDataReducer } from '../wizardImportPersonalDataReducer';
import {
    makeSelectWizardImportPersonalDataFileRowsAmount,
} from '../wizardImportPersonalDataSelectors';
import { WizardImportPersonalDataStyled } from './styled/WizardImportPersonalDataStyled';
import WizardImportPersonalDataTable from './WizardImportPersonalDataTable/WizardImportPersonalDataTable';

const WizardImportPersonalDataContentValidationStep = (props: IConnectedProps) => {
    const {
        fileRowsAmount,
        translation,
    } = props;

    const stepTranslation = translation[EWizardImportPersonalDataSteps.ContentValidationStep];

    return <WizardImportPersonalDataStyled>
        <div className="wizard-import-personal-data__title">{stepTranslation.title}</div>
        <InfoBlock className="wizard-import-personal-data__warning" colorStatus={EColorStatus.WARNING}>
            <div dangerouslySetInnerHTML={{
                __html: stepTranslation.warning,
            }}/>
        </InfoBlock>
        <div className="wizard-import-personal-data__info">
            {stringFormatParams(stepTranslation.counterLabel, { fileRowsAmount })}
        </div>
        <WizardImportPersonalDataTable
            translation={translation}
        />
    </WizardImportPersonalDataStyled>;
};

export interface IConnectedProps extends Pick<IWizardImportPersonalDataReducer, 'fileRowsAmount'> {
    translation: IWizardImportPersonalDataTranslation;
}

export const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    fileRowsAmount: makeSelectWizardImportPersonalDataFileRowsAmount(),
    translation: makeSelectTranslationWizardImportPersonalData(),
});

export default connect(mapStateToProps) (WizardImportPersonalDataContentValidationStep);
